import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "selected-documents__sheet" }
const _hoisted_2 = {
  class: "selected-documents-header",
  key: "header-content"
}
const _hoisted_3 = {
  class: "roboto-slab mb-0 loading",
  key: "loading-title"
}
const _hoisted_4 = { class: "selected-documents-header__summary" }
const _hoisted_5 = { class: "selected-documents__badge icons8-bill" }
const _hoisted_6 = { class: "selected-documents__count" }
const _hoisted_7 = { class: "roboto-slab mb-0" }
const _hoisted_8 = { class: "selected-documents-header__actions" }
const _hoisted_9 = { class: "bottom flex flex-column" }
const _hoisted_10 = {
  class: "selected-documents-body",
  key: "body-content"
}
const _hoisted_11 = {
  class: "white flex flex-align-center flex-justify-center flex-grow-1",
  key: "loader"
}
const _hoisted_12 = {
  class: "flex flex-column full-height",
  key: "download-overview"
}
const _hoisted_13 = { class: "overflow-container mt-2 pr pl-2 pb" }
const _hoisted_14 = { class: "button-container flex flex-justify-end white pa-2 flex-grow-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roba_loader = _resolveComponent("roba-loader")!
  const _component_document_block = _resolveComponent("document-block")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["selected-documents", { "is-open": _ctx.showAll, "is-downloading": _ctx.isDownloading }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "top",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAll = !_ctx.showAll))
      }, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.isDownloading)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.$t('DOCUMENTS.PREPARING_YOUR_DOWNLOAD')), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "selected-documents-header__spacer" }, null, -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.selectedDocumentsCount), 1)
                      ]),
                      _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('DOCUMENTS.SELECTED_DOCUMENTS')), 1),
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "icons8-sort-down" }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                          (!_ctx.showAll)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "text-button",
                                type: "button",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downloadDocuments && _ctx.downloadDocuments(...args)), ["stop"]))
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('COMMON.DOWNLOAD')), 1),
                                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "icons8-download" }, null, -1))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ])
                  ], 64))
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.isDownloading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_roba_loader, { percentage: _ctx.downloadPercentage }, null, 8, ["percentage"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDocuments, (document) => {
                        return (_openBlock(), _createBlock(_component_document_block, {
                          class: "mb",
                          document: document,
                          blockType: _ctx.blockTypes.download,
                          key: document.id
                        }, null, 8, ["document", "blockType"]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("button", {
                        class: "selected-documents__download-button",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadDocuments && _ctx.downloadDocuments(...args)))
                      }, _toDisplayString(_ctx.$t('DOCUMENTS.DOWNLOAD_DOCUMENTS')), 1)
                    ])
                  ]))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}